import React from 'react';

import { AppBar } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import MainHeader from '../../desktop/headers/MainHeader';

const useStyles = makeStyles((theme) => ({
  mainRoot: {
    '&.MuiAppBar-root': {
      width: '100%',
    },
    '&.MuiAppBar-positionFixed': {
      left: 0,
    },
    '&.MuiAppBar-colorPrimary': {
      backgroundColor: 'rgb(26, 26, 26)',
    },
    zIndex: theme.zIndex.drawer + 1,
    top: 0,
  },
}));

const Header = () => {
  const classes = useStyles();
  return (
    <AppBar elevation={0} position="static" className={classes.mainRoot}>
      <MainHeader mobile={true} />
    </AppBar>
  );
};

export default Header;
